import { AMLUserDetailPage } from "Components/AML/AMLUserDetail/AMLUserDetailPage";
import AMLUserListPage from "Components/AML/AMLUserList/AMLUserListPage";
import UserListPage from "Components/Users/UserListPage";
import { useCurrentUserHomepage } from "Hooks/useCurrentUserHomepage";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { Permission, UserStatus } from "Infrastructure/Api/Api";
import { AccessRightCodes } from "Models/AccessRightCodes";
import { AccessRoleCodes, PersonalRoleCodes } from "Models/AccessRoleCodes";
import ThanksToYouPage from "Pages/ThanksToYou/ThanksToYouPage";
import UserAccountPage from "Pages/UserAccountPage";
import { AnonymousDashboardPage } from "Pages/AnonymousDashboardPage";
import AppleRedirectPage from "Pages/Auth/AppleRedirectPage";
import AwaitingEmailVerificationPage from "Pages/Auth/AwaitingEmailVerificationPage";
import EmailVerificationPage from "Pages/Auth/EmailVerificationPage";
import ThanksToYouWithdrawalPage from "Pages/ThanksToYou/ThanksToYouWithdrawalPage";
import ForgottenPasswordPage from "Pages/Auth/ForgottenPasswordPage";
import GoogleCallbackPage from "Pages/Auth/GoogleCallbackPage";
import GoogleRedirectPage from "Pages/Auth/GoogleRedirectPage";
import { SetPasswordPage } from "Pages/Auth/SetPasswordPage";
import SignInPage from "Pages/Auth/SignInPage";
import SignUpPage from "Pages/Auth/SignUpPage";
import { BankAccountDetailPage } from "Pages/BankAccounts/BankAccountDetail/BankAccountDetailPage";
import BankAccountListPage from "Pages/BankAccounts/BankAccountListPage";
import BatchPaymentDetailPage from "Pages/Banking/BatchPayments/BatchPaymentDetailPage";
import BatchPaymentListPage from "Pages/Banking/BatchPayments/BatchPaymentListPage";
import BankingAuthPage from "Pages/Banking/Auth/BankingAuthPage";
import BankConnectionRankingPage from "Pages/Banking/BankConnectionRankingPage";
import AnonymousBankConnectionRankingPage from "Pages/Banking/AnonymousBankConnectionRankingPage";
import BankConnectionRankingDetailPage from "Pages/Banking/BankConnectionRankingDetailPage";
import AnonymousBankConnectionRankingDetailPage from "Pages/Banking/AnonymousBankConnectionRankingDetailPage";
import ContactPage from "Pages/ContactPage";
import AnonymousCustomerPaymentPayPage from "Pages/Customer/AnonymousCustomerPaymentPayPage";
import CustomerPaymentPayPage from "Pages/Customer/CustomerPaymentPayPage";
import SendPaymentPage from "Pages/Customer/SendPaymentPage";
import DashboardPage from "Pages/DashboardPage";
import Error403Page from "Pages/Error/Error403Page";
import Error404Page from "Pages/Error/Error404Page";
import { BlockedUsersPage } from "Pages/People/BlockedUsersPage";
import { FollowersPage } from "Pages/People/FollowersPage";
import { PeoplePage } from "Pages/People/PeoplePage";
import { PublicProfileRoute } from "Routes/PublicProfileRoute";
import { RoleSignUpRedirect } from "Pages/Auth/RoleSignUpRedirect";
import InitiateQRPaymentPage from "Pages/InitiateQRPaymentPage";
import { LegalDocumentsPage } from "Pages/LegalDocumentsPage";
import LicenseOrderPage from "Pages/LicenseOrderPage";
import { LicensePaymentPendingPage } from "Pages/LicensePaymentPendingPage";
import LicensesPage from "Pages/LicensesPage";
import MerchantCompleteRegistrationPage from "Pages/Merchant/MerchantCompleteRegistrationPage";
import MerchantInitiateKeypadPaymentPage from "Pages/Merchant/MerchantInitiateKeypadPaymentPage";
import StoriesPage from "Pages/Admin/StoriesPage";
import StoryCreatePage from "Pages/Admin/StoryCreatePage";
import StoryEditPage from "Pages/Admin/StoryEditPage";
import EmployeeInitiateKeypadPaymentPage from "Pages/Employee/EmployeeInitiateKeypadPaymentPage";
import MerchantInitiatePaymentDetailPage from "Pages/Merchant/MerchantInitiatePaymentDetail";
import MerchantInitiatePaymentPage from "Pages/Merchant/MerchantInitiatePaymentPage";
import MerchantNewRegistrationPage from "Pages/Merchant/MerchantNewRegistrationPage";
import MerchantOverviewPage from "Pages/Merchant/MerchantOverviewPage";
import MerchantDetailPage from "Pages/MerchantDetailPage";
import MerchantFeeCalculatorPage from "Pages/MerchantFeeCalculatorPage";
import MerchantOpenRegistrationsPage from "Pages/MerchantOpenRegistrationsPage";
import MerchantsPage from "Pages/MerchantsPage";
import AllMerchantsPage from "Pages/AllMerchantsPage";
import UnassignedMerchantsPage from "Pages/UnassignedMerchantsPage";
import HuntersPage from "Pages/HuntersPage";
import HunterDetailPage from "Pages/HunterDetailPage";
import NfcAssignPage from "Pages/NfcAssignPage";
import NfcExchangePage from "Pages/NfcExchangePage";
import { MigrationRequiredPage } from "Pages/Migration/MigrationRequiredPage";
import { CompleteCustomerOnboardingPage } from "Pages/Onboarding/CompleteCustomerOnboardingPage";
import { CompleteSSORegistrationPage } from "Pages/Onboarding/CompleteSSORegistrationPage";
import { OnboardingPage } from "Pages/Onboarding/OnboardingPage";
import { PayPointsPage } from "Pages/PayPoints/PayPointsPage";
import { PaypointDetailPage } from "Pages/PayPoints/PaypointDetailPage";
import { NewPaypointPage } from "Pages/PayPoints/NewPaypointPage";
import RateConfirmationPage from "Pages/RateConfirmationPage";
import BetaInfoPage from "Pages/Beta/BetaInfoPage";
import { LanguageSettingsPage } from "Pages/Settings/LanguageSettingsPage";
import NotificationSettingsPage from "Pages/Settings/NotificationSettingsPage";
import SettingsPage from "Pages/Settings/SettingsPage";
import ConnectedAppsPage from "Pages/Settings/ConnectedAppsPage";
import SsoAuthorizePage from "Pages/Sso/SsoAuthorizePage";
import SettlementsPage from "Pages/Settlements";
import { MerchantSettlementsPage } from "Pages/Settlements/MerchantSettlementsPage";
import StardustPage from "Pages/StardustPage";
import AllChallengesPage from "Pages/AllChallengesPage";
import SystemControlPage from "Pages/System/SystemControlPage";
import SystemReportPage from "Pages/System/SystemReportPage";
import { AnonymousTransactionDetailPage } from "Pages/Transactions/AnonymousTransactionDetailPage";
import LatestPayPointTransaction from "Pages/Transactions/LatestPayPointTransaction";
import { AnonymousCollectorPaymentPage } from "Pages/Customer/AnonymousCollectorPaymentPage";
import { FixedCollectorPaymentPage } from "Pages/Customer/FixedCollectorPaymentPage";
import { VariableCollectorPaymentPage } from "Pages/Customer/VariableCollectorPaymentPage";
import TransactionDetailPage from "Pages/Transactions/TransactionDetailPage";
import TransactionsPage from "Pages/Transactions/TransactionsPage";
import UserDetailPage from "Pages/UserDetailPage";
import { AnonymousRoute } from "Routes/AnonymousRoute";
import { AuthenticatedRoute } from "Routes/AuthenticatedRoute";
import { AuthorizedRoute } from "Routes/AuthorizedRoute";
import { OnboardingRoute } from "Routes/OnboardingRoute";
import { RoleAuthorizedRoute } from "Routes/RoleAuthorizedRoute";
import { isAuthenticated } from "Utils/AuthUtils";
import { getAppUrl } from "Utils/UrlUtils";
import { STORY_AUTHOR_ROLES } from "Utils/Stories/storyAuthoring";
import { wrapUseRoutesV7 } from "@sentry/react";
import { useRoutes } from "react-router-dom";
import { Navigate } from "Navigation/Navigate";
import EmployeesPage from "Pages/Employee/EmployeesPage";
import EmployeeDetailPage from "Pages/Employee/EmployeeDetailPage";
import CreateEmployeePage from "Pages/Employee/CreateEmployeePage";
import { ValorPage } from "Pages/Loyalty/ValorPage";
import { NotificationsPage } from "Pages/NotificationsPage";
import { InvitationsInboxPage } from "Pages/Invitations/InvitationsInboxPage";
import { AddRolePage } from "Pages/Roles/AddRolePage";
import { AddRoleOnboardingPage } from "Pages/Roles/AddRoleOnboardingPage";
import { NotificationsManagementPage } from "Pages/NotificationsManagementPage";
import { NewNotificationPage } from "Pages/NewNotificationPage";
import { EditNotificationPage } from "Pages/EditNotificationPage";
import ToBeVerifiedPage from "Pages/Admin/ToBeVerifiedPage";
import RolesPermissionsPage from "Pages/Admin/RolesPermissionsPage";
import CampaignsPage from "Pages/Admin/CampaignsPage";
import CouponsPage from "Pages/Admin/CouponsPage";
import SsoClientsPage from "Pages/Admin/SsoClientsPage";
import TerminalsPage from "Pages/Admin/TerminalsPage";
import { RaffleRoundsPage } from "Pages/Admin/RaffleRoundsPage";
import { RafflePage } from "Pages/RafflePage";
import CampaignCreatePage from "Pages/Admin/CampaignCreatePage";
import CampaignEditPage from "Pages/Admin/CampaignEditPage";
import CampaignPage from "Pages/Campaigns/CampaignPage";
import { WhereToPayPage } from "Pages/WhereToPayPage";
import { StoreDetailPage } from "Pages/StoreDetailPage";
import { ReadOnlyMerchantDetailPage } from "Pages/MerchantReadOnlyDetailPage";
import TransferPage from "Pages/Transfer/TransferPage";
import { ChatPage } from "Pages/ChatPage";

const appUrl = getAppUrl(true);

const useSentryRoutes = wrapUseRoutesV7(useRoutes);

const Routes = () => {
  const user = useLoggedInUser();
  const isUserAuthenticated = isAuthenticated(user);
  const isAnonymousUserAuthenticated =
    isAuthenticated(user) && user?.userStatus === UserStatus.Anonymous;
  const { HomepageComponent } = useCurrentUserHomepage();

  return useSentryRoutes([
    {
      path: "",
      element: isUserAuthenticated ? (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          {HomepageComponent ? <HomepageComponent /> : <DashboardPage />}
        </AuthenticatedRoute>
      ) : (
        <SignInPage />
      ),
    },
    {
      path: appUrl("bank-connection-ranking"),
      element: (
        <AuthenticatedRoute
          isUserAuthenticated={isUserAuthenticated}
          allowAnonymous
        >
          <AnonymousRoute
            isUserAuthenticated={isUserAuthenticated}
            isAnonymousUserAuthenticated={isAnonymousUserAuthenticated}
            authenticatedComponent={<BankConnectionRankingPage />}
            unauthenticatedComponent={<AnonymousBankConnectionRankingPage />}
          />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("bank-connection-ranking-detail"),
      element: (
        <AuthenticatedRoute
          isUserAuthenticated={isUserAuthenticated}
          allowAnonymous
        >
          <AnonymousRoute
            isUserAuthenticated={isUserAuthenticated}
            isAnonymousUserAuthenticated={isAnonymousUserAuthenticated}
            authenticatedComponent={<BankConnectionRankingDetailPage />}
            unauthenticatedComponent={
              <AnonymousBankConnectionRankingDetailPage />
            }
          />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("sign-in"),
      element: <SignInPage />,
    },
    {
      path: appUrl("campaign"),
      element: <CampaignPage />,
    },
    {
      path: appUrl("google-redirect"),
      element: <GoogleRedirectPage />,
    },
    {
      path: appUrl("google-callback"),
      element: <GoogleCallbackPage />,
    },
    {
      path: appUrl("apple-redirect"),
      element: <AppleRedirectPage />,
    },
    {
      path: appUrl("sign-up"),
      element: <SignUpPage />,
    },
    // Retired merchant registration — links in circulation redirect to the Customer-first
    // sign-up carrying the role as an intent.
    {
      path: appUrl("sign-up-merchant"),
      element: <RoleSignUpRedirect roleIntent={AccessRoleCodes.Merchant} />,
    },
    // Retired hunter self-signup — links in circulation redirect to the Customer-first
    // sign-up carrying the role as an intent.
    {
      path: appUrl("sign-up-hunter"),
      element: <RoleSignUpRedirect roleIntent={AccessRoleCodes.Hunter} />,
    },
    {
      path: appUrl("forgottenPassword"),
      element: <ForgottenPasswordPage />,
    },
    {
      path: appUrl("setPassword"),
      element: <SetPasswordPage />,
    },
    {
      path: appUrl("merchants"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Merchants}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <MerchantsPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("merchant-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Merchants}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <MerchantDetailPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("shared-merchant-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Merchants}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <ReadOnlyMerchantDetailPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("merchant-new-registration"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <MerchantNewRegistrationPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("merchant-complete-registration"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <MerchantCompleteRegistrationPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("merchant-open-registrations"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <MerchantOpenRegistrationsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("merchant"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <MerchantOverviewPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("merchant-settlements"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Settlements}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <MerchantSettlementsPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("initiate-keypad-payment"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Merchant]}
            userAccessRole={user?.accessRoleCode}
          >
            <MerchantInitiateKeypadPaymentPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-stories"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={STORY_AUTHOR_ROLES}
            userAccessRole={user?.accessRoleCode}
          >
            <StoriesPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-stories-create"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={STORY_AUTHOR_ROLES}
            userAccessRole={user?.accessRoleCode}
          >
            <StoryCreatePage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-stories-edit"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={STORY_AUTHOR_ROLES}
            userAccessRole={user?.accessRoleCode}
          >
            <StoryEditPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      // Retired one-shot post page — stale links land on the create form.
      path: appUrl("admin-stories-post"),
      element: <Navigate to={appUrl("admin-stories-create")} replace />,
    },
    {
      path: appUrl("employee-initiate-keypad-payment"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Employee]}
            userAccessRole={user?.accessRoleCode}
          >
            <EmployeeInitiateKeypadPaymentPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("initiate-form-payment"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.Customer,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <MerchantInitiatePaymentPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("initiate-qr-payment"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.Customer,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.HunterPlus,
              AccessRoleCodes.Hunter,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <InitiateQRPaymentPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("initiate-payment-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.Employee,
              AccessRoleCodes.Customer,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <MerchantInitiatePaymentDetailPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("user-account"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <UserAccountPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("affiliate"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <ThanksToYouPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("transfer-between-accounts"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <TransferPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("transfer-between-accounts"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <TransferPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("chat"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <ChatPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("transactions"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <TransactionsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("people"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <PeoplePage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("followers"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <FollowersPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("blocked-users"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <BlockedUsersPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("transaction-detail"),
      element: (
        <AuthenticatedRoute
          isUserAuthenticated={isUserAuthenticated}
          allowAnonymous
        >
          <AnonymousRoute
            isUserAuthenticated={isUserAuthenticated}
            isAnonymousUserAuthenticated={isAnonymousUserAuthenticated}
            authenticatedComponent={<TransactionDetailPage />}
            unauthenticatedComponent={<AnonymousTransactionDetailPage />}
          />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("settings"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <SettingsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("beta"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <BetaInfoPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("notification-settings"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <NotificationSettingsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("notifications"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <NotificationsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("invitations"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <InvitationsInboxPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("add-role"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={PersonalRoleCodes}
            userAccessRole={user?.accessRoleCode}
            protectionMode="404"
          >
            <AddRolePage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("add-role-onboarding"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={PersonalRoleCodes}
            userAccessRole={user?.accessRoleCode}
            protectionMode="404"
          >
            <AddRoleOnboardingPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("notifications-management"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Admin, AccessRoleCodes.AdminLite]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Notifications}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <NotificationsManagementPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("new-notification"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Admin]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Notifications}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Create}
            >
              <NewNotificationPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("edit-notification"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Admin, AccessRoleCodes.AdminLite]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Notifications}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Update}
            >
              <EditNotificationPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("language-settings"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <LanguageSettingsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("contact"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <ContactPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("dashboard"),
      element: (
        <AuthenticatedRoute
          isUserAuthenticated={isUserAuthenticated}
          allowAnonymous
        >
          <AnonymousRoute
            isUserAuthenticated={isUserAuthenticated}
            isAnonymousUserAuthenticated={isAnonymousUserAuthenticated}
            authenticatedComponent={<DashboardPage />}
            unauthenticatedComponent={<AnonymousDashboardPage />}
          />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("email-verification"),
      element: <EmailVerificationPage />,
    },
    {
      // ZS-1623: the opt-out confirmation link from the e-mail — anonymous, the token is the proof.
      path: appUrl("thanks-to-you-withdrawal"),
      element: <ThanksToYouWithdrawalPage />,
    },
    {
      path: appUrl("awaiting-email-verification"),
      element: <AwaitingEmailVerificationPage />,
    },
    {
      // Retired hunter sign-up used to land here — keep the URL alive for stale tabs/history.
      path: appUrl("awaiting-hunter-email-verification"),
      element: <AwaitingEmailVerificationPage />,
    },
    {
      path: appUrl("rate-confirmation"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RateConfirmationPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("system"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.SystemControl}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <SystemReportPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("system-control"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.SystemControl}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <SystemControlPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("user-list"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.Aml,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
            protectionMode="404"
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Users}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <UserListPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("to-be-verified"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Users}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <ToBeVerifiedPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("roles-permissions"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Admin, AccessRoleCodes.AdminLite]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Permissions}
              requiredPermission={Permission.Read}
              userAccessRights={user?.accessRights ?? []}
            >
              <RolesPermissionsPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-campaigns"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Campaigns}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <CampaignsPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("sso-authorize"),
      element: (
        <AuthenticatedRoute
          isUserAuthenticated={isUserAuthenticated}
          isStandalone
        >
          <SsoAuthorizePage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("connected-apps"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <ConnectedAppsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-sso-clients"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Admin]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.SystemControl}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <SsoClientsPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-coupons"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Coupons}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <CouponsPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-terminals"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.TerminalInventory}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <TerminalsPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-raffle"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          {/* Role gate is load-bearing: Customers hold Raffle Read + Update (own ticket moves, R7),
              so the right alone would open this page to them with manage actions lit. */}
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Admin, AccessRoleCodes.AdminLite]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Raffle}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <RaffleRoundsPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-campaigns-create"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Campaigns}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Create}
            >
              <CampaignCreatePage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("admin-campaigns-edit"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Campaigns}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <CampaignEditPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("user-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.Aml,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
            protectionMode="404"
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Users}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read} //In here the role auth above is also necessary, we don't want customer role users to be able to navigate here, despite having Users READ permission
            >
              <UserDetailPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("aml-users"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Aml]}
            userAccessRole={user?.accessRoleCode}
            protectionMode="404"
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Users}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <AMLUserListPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("aml-user-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Aml]}
            userAccessRole={user?.accessRoleCode}
            protectionMode="404"
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Users}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <AMLUserDetailPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("bank-address-list"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.Customer,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.Hunter,
              AccessRoleCodes.HunterPlus,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <BankAccountListPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("bank-account-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.Customer,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.Hunter,
              AccessRoleCodes.HunterPlus,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <BankAccountDetailPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("banking-auth"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.Customer,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.Hunter,
              AccessRoleCodes.HunterPlus,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <BankingAuthPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("batch-payments"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.Merchant,
              AccessRoleCodes.AdminLite,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Banking}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <BatchPaymentListPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("batch-payment-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.Merchant,
              AccessRoleCodes.AdminLite,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Banking}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <BatchPaymentDetailPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("complete-customer-onboarding"),
      element: (
        <OnboardingRoute isUserAuthenticated={isUserAuthenticated}>
          <CompleteCustomerOnboardingPage />
        </OnboardingRoute>
      ),
    },
    {
      path: appUrl("customer-payment-pay"),
      element: (
        <AnonymousRoute
          isUserAuthenticated={isUserAuthenticated}
          isAnonymousUserAuthenticated={isAnonymousUserAuthenticated}
          authenticatedComponent={<CustomerPaymentPayPage />}
          unauthenticatedComponent={<AnonymousCustomerPaymentPayPage />}
        />
      ),
    },
    {
      path: appUrl("send-payment"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <SendPaymentPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("onboarding"),
      element: (
        <OnboardingRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.HunterPlus,
              AccessRoleCodes.Hunter,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <OnboardingPage />
          </RoleAuthorizedRoute>
        </OnboardingRoute>
      ),
    },
    {
      path: appUrl("complete-sso-registration"),
      element: (
        <OnboardingRoute isUserAuthenticated={isUserAuthenticated}>
          <CompleteSSORegistrationPage />
        </OnboardingRoute>
      ),
    },
    {
      path: appUrl("migration-required"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <MigrationRequiredPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("license-payment-pending"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <LicensePaymentPendingPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("licenses"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <LicensesPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("orderLicense"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <LicenseOrderPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("latest-pay-point-transaction"),
      element: <LatestPayPointTransaction />,
    },
    {
      path: appUrl("legal-documents"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <LegalDocumentsPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("merchant-fee-calculator"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Dashboard}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <MerchantFeeCalculatorPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("employees"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Merchant]}
            userAccessRole={user?.accessRoleCode}
          >
            <EmployeesPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("employee-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Merchant]}
            userAccessRole={user?.accessRoleCode}
          >
            <EmployeeDetailPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("create-employee"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Merchant]}
            userAccessRole={user?.accessRoleCode}
          >
            <CreateEmployeePage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("paypoints"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Merchant]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Paypoints}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <PayPointsPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("paypoint-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.Hunter,
              AccessRoleCodes.HunterPlus,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Paypoints}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <PaypointDetailPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("new-paypoint"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Dashboard}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <NewPaypointPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("settlements"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Settlements}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <SettlementsPage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("nfc-assign"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Merchant,
              AccessRoleCodes.HunterPlus,
              AccessRoleCodes.Hunter,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <NfcAssignPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("valor"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.HunterPlus,
              AccessRoleCodes.Hunter,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <ValorPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("nfc-exchange"),
      element: <NfcExchangePage />,
    },
    {
      path: appUrl("fixed-collector-paypoint"),
      element: (
        <AnonymousRoute
          isUserAuthenticated={isUserAuthenticated}
          isAnonymousUserAuthenticated={isAnonymousUserAuthenticated}
          authenticatedComponent={<FixedCollectorPaymentPage />}
          unauthenticatedComponent={<AnonymousCollectorPaymentPage />}
        />
      ),
    },
    {
      path: appUrl("variable-collector-paypoint"),
      element: (
        <AnonymousRoute
          isUserAuthenticated={isUserAuthenticated}
          isAnonymousUserAuthenticated={isAnonymousUserAuthenticated}
          authenticatedComponent={<VariableCollectorPaymentPage />}
          unauthenticatedComponent={<AnonymousCollectorPaymentPage />}
        />
      ),
    },
    {
      path: appUrl("stardust"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <StardustPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("raffle"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AuthorizedRoute
            requiredAccessRight={AccessRightCodes.Raffle}
            userAccessRights={user?.accessRights ?? []}
            requiredPermission={Permission.Read}
          >
            <RafflePage />
          </AuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("all-challenges"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <AllChallengesPage />
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("where-to-pay"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Customer]}
            userAccessRole={user?.accessRoleCode}
          >
            <WhereToPayPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("store-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.Customer]}
            userAccessRole={user?.accessRoleCode}
          >
            <StoreDetailPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("all-merchants"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[AccessRoleCodes.HunterPlus]}
            userAccessRole={user?.accessRoleCode}
          >
            <AllMerchantsPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("unassigned-merchants"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.CustomerOnboarding,
              AccessRoleCodes.HunterPlus,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <AuthorizedRoute
              requiredAccessRight={AccessRightCodes.Merchants}
              userAccessRights={user?.accessRights ?? []}
              requiredPermission={Permission.Read}
            >
              <UnassignedMerchantsPage />
            </AuthorizedRoute>
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("hunters"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.HunterPlus,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <HuntersPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    {
      path: appUrl("hunter-detail"),
      element: (
        <AuthenticatedRoute isUserAuthenticated={isUserAuthenticated}>
          <RoleAuthorizedRoute
            allowedRoles={[
              AccessRoleCodes.HunterPlus,
              AccessRoleCodes.Admin,
              AccessRoleCodes.AdminLite,
              AccessRoleCodes.CustomerOnboarding,
            ]}
            userAccessRole={user?.accessRoleCode}
          >
            <HunterDetailPage />
          </RoleAuthorizedRoute>
        </AuthenticatedRoute>
      ),
    },
    { path: appUrl("403"), element: <Error403Page /> },
    // Public profile URL /profile/{key} — key is a handle or a persona PublicID; the route
    // itself 404s keys that are neither. Serves BOTH audiences: signed-in viewers get the
    // app layout, anonymous visitors the bare page.
    { path: appUrl("public-profile"), element: <PublicProfileRoute /> },
    { path: "*", element: <Error404Page /> },
  ]);
};

export { Routes };
